import { render, staticRenderFns } from "./PatientAgreementsDetailsModal.vue?vue&type=template&id=2ba6ec3e&scoped=true&"
import script from "./PatientAgreementsDetailsModal.vue?vue&type=script&lang=js&"
export * from "./PatientAgreementsDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientAgreementsDetailsModal.vue?vue&type=style&index=0&id=2ba6ec3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6ec3e",
  null
  
)

component.options.__file = "PatientAgreementsDetailsModal.vue"
export default component.exports